// This file intentionally has no external dependencies

/**
 * Attempts to update the AppCache
 */
export function updateAppCache() {
    if (window.serviceWorkerEnabled && "serviceWorker" in navigator) {
        // If the service worker is active, don't update AppCache
        return;
    }
    if (window.applicationCache && window.applicationCache.status && window.applicationCache.status === window.applicationCache.IDLE) {
        try {
            window.applicationCache.update();
        } catch (e) {
            if (e.code === DOMException.INVALID_STATE_ERR || e.name === "InvalidStateError") {
                // Browser purged the appcache. Trigger it to download again by reloading the app.
                window.location.reload();
                return;
            }
            throw e;
        }
    }
}